import { useMutation } from '@tanstack/react-query'
import { postRequest } from 'utils/api/apiRequest'
import type { OnSuccessApi } from 'utils/getOptionsTable'

type Data = OnSuccessApi<{ template: string }> & {
  id: number
  language: string
  profile: number
  note?: string
  reason?: string
}
export const usePostSubscriberMessageTemplatePreview = () => {
  return useMutation({
    mutationFn: ({ id, onSuccess, ...data }: Data) => postRequest(`/subscriber/message-templates/${id}/preview`, data),
    onSuccess: (data, variables) => {
      if (variables.onSuccess) {
        variables.onSuccess({ template: data?.data?.template || '' })
      }
    },
  })
}
